import "./pill.scss";
import React from "react";

function Pill(props) {
  const { title, key, onClick, className = `` } = props;
  return (
    <button className={`pill ${className}`} onClick={onClick} key={key}>
      {title}
    </button>
  );
}

export default Pill;
